import { DarkFlatButton } from 'components/common';
import styled from 'styled-components';
import { BackButtonStyled } from '../Header/BackButton/BackButton.styled';

export const DarkHeader = styled.div`
    width: 100%;
    padding: 1.6rem 4rem;
    min-height: 6.4rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        min-height: 5.6rem;
        padding: 0.8rem 2.4rem;
        background-color: ${({ theme }) => theme.colors.darkBlue};
        ${BackButtonStyled}, ${DarkFlatButton} {
            & > svg * {
                fill: ${({ theme }) => theme.colors.silverGrey[500]};
            }

            & > span {
                display: none;
            }
        }
    }
`;
